import React from 'react'
import LockIcon from 'images/inline/lock-new.svg'

export function LockedContent({ children, label }) {
  return (
    <div className="gated-content">
      <div className="gated-content--lock">
        <LockIcon />
        <p>{label}</p>
      </div>
      <div className="blur">{children}</div>
    </div>
  )
}
